module.exports = __webpack_public_path__ + "assets/img/Edito_Franck-Bonin_cover.69782b08-ps.jpg";